import { render, staticRenderFns } from "./EntryDetails.vue?vue&type=template&id=a6bad7c2"
import script from "./EntryDetails.vue?vue&type=script&lang=ts"
export * from "./EntryDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports